import React, { Component } from "react";
import FormGroup from "@material-ui/core/FormGroup";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import PopupMessage from "../components/PopupMessage";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

const styles = (theme) => ({
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP + ACCOUNTS_TOOLBAR_HEIGHT + 10}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
});

class SandBarcodePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      viewPopup: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
  }

  componentDidMount() {
    fetch("on_check_Locked_item", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }
  render() {
    const { classes } = this.props;
    let { t } = this.props;
    return (
      <div>
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        <div className={classes.toolbar}>
          <FormGroup row>
            <Typography variant="h6" color="primary">
              &nbsp;{t("sandBarcode.label")}
            </Typography>
          </FormGroup>
          <Divider />
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(SandBarcodePage));
